import { FeatureFlag } from '../FeatureFlag';

export const enableOwnerInvitation = new FeatureFlag({
    key: 'enable-owner-invitation',
    createdOn: '2024-04-17',
    defaultValue: false,
});
